import { createApp } from 'vue'
import StafetDonationFlow from './StafetDonationFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-donation-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationFlowDOM) => {
            const externalData = StafetDonationFlowDOM.dataset.external
                ? JSON.parse(StafetDonationFlowDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                holdList: externalData.holdList ?? null,
                userData: externalData.userData ?? null,
                loggedIn: isObjectNotNullOrEmpty(externalData.userData),
                minimumDonationAmount: externalData.minimumDonationAmount ?? 1,
                holdId: externalData.holdId ?? '',
                deltagerId: externalData.deltagerId ?? '',
                donationAmounts: externalData.donationAmounts ?? []
            }
            const component = createApp(StafetDonationFlow, props).use(Store)
            component.mount(StafetDonationFlowDOM)
        })
    }
}
